import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { PATH_DASHBOARD } from 'routers/paths';
import { RoleRouter } from 'routers/RoleRouter';
import { ROLES } from '../../../config';

const Regions = lazy(() => import('pages/settings/Regions'));
const GlobalSettings = lazy(() => import('pages/settings/GlobalSettings'));
const Users = lazy(() => import('pages/settings/Users'));
const Bonuses = lazy(() => import('pages/settings/Bonuses'));
const Influencers = lazy(() => import('pages/settings/Influencers'));
const Benefits = lazy(() => import('pages/settings/OakleyBenefits'));
const ProgressLevels = lazy(() => import('pages/settings/ProgressLevels'));

const NotFound = lazy(() => import('pages/Page404'));

export default function Settings() {
  return (
    <Routes>
      <Route
        path={`${PATH_DASHBOARD.regions.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <Regions />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.globalSettings.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.SUPER_ADMIN]}>
            <GlobalSettings />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.users.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <Users />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.bonuses.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.SUPER_ADMIN]}>
            <Bonuses />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.oakleyBenefits.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <Benefits />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.influencers.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <Influencers />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.progressLevels.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.SUPER_ADMIN]}>
            <ProgressLevels />
          </RoleRouter>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
